import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedNumber } from 'react-intl';
import { Icon } from 'react-spark';
import button from '../../button';
import { round } from '../../../helpers/filters'
import Tooltip from '../../tooltip/Tooltip';
import { offerSchema } from '../../offers-page-schemas';

import reduxOffer from '../../redux/offer';

const actionCreator = reduxOffer.actionCreator;

const { baseButton: Button } = button;

export class OffersTableRow extends Component {
    aprTooltipText(offer) {
        return `This is based off of the rate of the loan, ${round(
            offer.rate,
            3
        )}%,\n
    and an origination fee of ${round(
            offer.originationFeeRate,
            3
        )}% \n
    ($${round(offer.originationFee, 2)}) \n
    which will be deducted from the proceeds of the loan. These numbers are an estimate.`;
    }

    render() {
        const { isSelectingOffer, offer, selectOffer } = this.props;

        return (
            <Fragment>
                <tr>
                    <td><Button
                        id={`SelectButton-${offer.amount}-${offer.duration}`}
                        name={`SelectButton-${offer.amount}-${offer.duration}`}
                        onClick={() => selectOffer(offer.id)}
                        disabled={isSelectingOffer}
                    >
                Select
                    </Button></td>
                    <td>$<FormattedNumber value={offer.amount} style="decimal" maximumFractionDigits={0} /></td>
                    <td><FormattedNumber value={offer.monthlyPayment} style="currency" currency="USD" /></td>
                    <td>{offer.duration} Mo.</td>
                    <td><FormattedNumber value={offer.rate} style="decimal" minimumFractionDigits={3} maximumFractionDigits={3} />%</td>
                    <td><FormattedNumber value={offer.annualPercentageRate} style="decimal" minimumFractionDigits={3} maximumFractionDigits={3} />%{' '}
                        <Tooltip
                            id="offer-apr-tooltip"
                            text={this.aprTooltipText(offer)}
                        >
                            <Icon name="question" />
                        </Tooltip>
                    </td>
                </tr>
            </Fragment>
        );
    }
}

OffersTableRow.propTypes = {
    offer: offerSchema.isRequired,
    isSelectingOffer: PropTypes.bool.isRequired,
    selectOffer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    selectOffer: (offerId) => dispatch((_, getState) => {
        const state = getState();
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
            dispatch(actionCreator.selectOfferAuthenticated(offerId, state.loan.loanJson.loanId));
        } else {
            dispatch(actionCreator.selectOffer(offerId))
        }
    }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersTableRow);
